import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EmptyPageProps {
	title?: string;
	subtitle?: string;
	buttonText?: string;
	onButtonClick?: () => void;
}

export const EmptyPage = ({ title, subtitle, buttonText, onButtonClick }: EmptyPageProps) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '40px',
				gap: '16px',
				minHeight: '300px',
				width: '100%',
				height: '100%',
			}}
		>
			{title && (
				<Typography
					variant="h5"
					sx={{
						color: '#343A40',
						textAlign: 'center',
						fontWeight: 600,
					}}
				>
					{title}
				</Typography>
			)}
			{subtitle && (
				<Typography
					variant="body1"
					sx={{
						color: '#6C757D',
						textAlign: 'center',
						fontWeight: 400,
					}}
				>
					{subtitle}
				</Typography>
			)}
			{buttonText && onButtonClick && (
				<Button
					variant="contained"
					onClick={onButtonClick}
					sx={{
						mt: 2,
						textTransform: 'none',
					}}
				>
					{buttonText}
				</Button>
			)}
		</Box>
	);
};
